import script from "./manage-certificate-types.vue?vue&type=script&setup=true&lang=js"
export * from "./manage-certificate-types.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__